import React from "react";
import { Check, ShieldCheck, Clock, Award } from "lucide-react";
import { Meta } from "../components/SEO";
import { QuoteForm } from "../components/QuoteForm";
import { company } from "../data/company";

const points = [
  { icon: Clock, t: "Binnen 1 werkdag reactie", d: "Persoonlijk telefonisch contact om uw aanvraag te bespreken." },
  { icon: Award, t: "Vaste prijs offerte", d: "Heldere uitwerking — wijzigingen worden altijd vooraf schriftelijk vastgelegd." },
  { icon: ShieldCheck, t: "Vakkundig en geregistreerd", d: "VCA-gecertificeerde medewerkers en KvK-geregistreerd. Vast uitvoeringsteam met vertrouwde specialistische partners." },
];

export default function OffertePage() {
  return (
    <>
      <Meta
        title="Offerte aanvragen — Aannemer Zuid-Holland | Koning"
        description="Vraag in 3 stappen een vrijblijvende offerte aan voor uw renovatie of verbouwing. Binnen één werkdag persoonlijk contact en een vaste prijs zonder verrassingen."
      />

      <section className="pt-24 pb-12 md:pt-32 md:pb-16 border-b border-koning-border" data-testid="offerte-hero">
        <div className="max-w-[1480px] mx-auto px-6 md:px-12 lg:px-20">
          <div className="eyebrow mb-5">Vrijblijvende offerte</div>
          <h1 className="font-display text-4xl md:text-6xl lg:text-7xl text-white tracking-tight max-w-4xl">
            Vraag uw <span className="italic text-koning-gold">offerte</span> aan in 3 stappen
          </h1>
          <p className="mt-6 text-koning-muted max-w-2xl leading-relaxed">
            Vul onderstaand formulier in. Binnen één werkdag nemen wij persoonlijk contact op om uw project te bespreken en een vrijblijvende offerte op te stellen.
          </p>
        </div>
      </section>

      <section className="py-20 md:py-28" data-testid="offerte-grid">
        <div className="max-w-[1480px] mx-auto px-6 md:px-12 lg:px-20 grid lg:grid-cols-[1fr_1.4fr] gap-14 items-start">
          <div>
            <h2 className="font-display text-2xl md:text-3xl text-white">Wat u kunt verwachten</h2>
            <ul className="mt-8 space-y-7">
              {points.map((p) => (
                <li key={p.t} className="flex gap-4">
                  <div className="w-12 h-12 border border-koning-gold flex items-center justify-center text-koning-gold flex-shrink-0"><p.icon size={18} /></div>
                  <div>
                    <div className="font-display text-white text-xl">{p.t}</div>
                    <p className="mt-1 text-koning-muted text-sm leading-relaxed">{p.d}</p>
                  </div>
                </li>
              ))}
            </ul>

            <div className="mt-10 border border-koning-border p-6">
              <div className="text-xs tracking-[0.24em] uppercase text-koning-muted mb-3">Liever direct contact?</div>
              <a href={company.phoneHref} className="font-display text-2xl text-koning-gold hover:underline" data-testid="offerte-direct-phone">{company.phone}</a>
              <a href={company.whatsappHref} target="_blank" rel="noopener noreferrer" className="mt-2 text-koning-muted text-sm hover:text-white block">WhatsApp: {company.whatsapp}</a>
            </div>

            <div className="mt-8">
              <div className="text-xs tracking-[0.24em] uppercase text-koning-muted mb-3">Onze garanties</div>
              <ul className="space-y-2">
                {[
                  "VCA-gecertificeerde medewerkers",
                  "Vaste prijs, schriftelijk vastgelegd",
                  "Vast uitvoeringsteam en vertrouwde specialistische partners",
                  "Fabrieksgarantie op gebruikte A-merken",
                ].map((b) => (
                  <li key={b} className="flex items-start gap-3 text-sm text-koning-text"><Check size={16} className="text-koning-gold mt-1" /> {b}</li>
                ))}
              </ul>
            </div>
          </div>

          <div>
            <QuoteForm />
          </div>
        </div>
      </section>
    </>
  );
}
